module.exports = __webpack_public_path__ + "static/media/marca-negro.def51949.png";